export default __webpack_public_path__ + "static/media/progress-bar.df2dae76.gif";